import { DEALER_STATUS } from '../constants/app-constants';

export const isValidDealer = (status) => {
    return ![DEALER_STATUS.BANNED, DEALER_STATUS.ENLISTED].includes(status);
};